import { render } from "./Contact.vue?vue&type=template&id=0bafe23a"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/private/messages/Contact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bafe23a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bafe23a', __exports__)) {
    api.reload('0bafe23a', __exports__)
  }
  
  module.hot.accept("./Contact.vue?vue&type=template&id=0bafe23a", () => {
    api.rerender('0bafe23a', render)
  })

}


export default __exports__